<script>
import { mapGetters } from 'vuex'

import Translatable from '@src/mixins/translatable.js'

export default {
  mixins: [
    Translatable
  ],
  props: {
    card: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('eShop', [
      'selectedType'
    ]),
    cardName() {
      const name = this.card.data.name.default
      .replace('Day', this.getTranslatedContent('ESHOP_product_name_DAY'))
      .replace('Prague', this.getTranslatedContent('ESHOP_product_name_PRAGUE'))
      .replace('Adult', this.getTranslatedContent('ESHOP_product_name_ADULT'))
      .replace('Child/Student', this.getTranslatedContent('ESHOP_product_name_CHILD_STUDENT'))

      return this.selectedType === 'coolpass' ?
      name.replace('Card', this.getTranslatedContent('ESHOP_product_name_COOLPASS')) :
      name.replace('Card', this.getTranslatedContent('ESHOP_product_name_CARD'))
    },
    price() {
      return this.card.data.price
    },
    count() {
      return this.card.count
    },
    sum() {
      return this.card.sum
    },
  },
  methods: {
    deleteCard(cardId, cardType, cardTypeId) {
      this.$store.commit('eShop/DELETE_CARD', {cardId, cardType, cardTypeId})
      // this.scrollToElement({behavior: 'smooth'})
      // setTimeout(() => this.$store.commit('eShop/DELETE_CARD', {cardId, cardType, cardTypeId}), 400)
    },
    // scrollToElement(options) {
    //   const el = document.querySelector('.calculator-section')

    //   if (el) {
    //     el.scrollIntoView(options);
    //   }
    // },
  },
}
</script>

<template>
  <div v-if="count" class="list-item">
    <div class="list-item-text type">{{ cardName }}</div>
    <div class="list-item-text calc">{{`${count}×${price} EUR`}}</div>
    <div class="list-item-text total">{{`${sum} EUR`}}</div>
    <div class="cross" @click="deleteCard(card.cardId, card.type, card.data.id)"></div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.list-item {
  width: 657px;
  height: 70px;
  border-top: 1px solid $dark-gray;
  border-bottom: 1px solid $dark-gray;
  padding: 0 28px;

  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.list-item-text {
  font-family: Open Sans Bold;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;
  text-align: center;
  color: $gray;

  margin-right: 20px;


  &.type {
    min-width: 170px;
    text-align: left;
  }

  &.calc {
    min-width: 280px;
  }

  &.total {
    min-width: 130px;
    text-align: left;
  }

  &.sum {
    font-size: 18px;
    line-height: 23px;
    color: $black;
  }

  &.green {
    color: $green;
  }
}

.cross {
  background: url("../../assets/icons/e-x.svg") center no-repeat;
  cursor: pointer;
  min-width: 24px;
  width: 24px;
  height: 24px;
  z-index: 10;
}

@media only screen and (max-width: $screen-width-xs) {
  .list-items {
    width: 100%;
  }
  .list-item, .list-total{
    width: 100%;
    height: 70px;
    padding: 0;

    justify-content: space-between;
    flex-wrap: wrap;
  }

  .list-item-text {
    margin-right: 5px;

    &.type {
      min-width: 112px;
      max-width: 112px;
      text-align: left;
      margin-left: 8px;
    }

    &.calc {
      min-width: 80px;
    }

    &.total {
      min-width: 43px;
      text-align: left;
    }
  }

  .cross {
    transform: scale(0.80);
    margin-right: 3px;
  }
}

</style>
